<template>
    <div v-if="webpChecked" id="app">
        <template v-if="onlyView">
            <router-view></router-view>
        </template>

        <template v-else>
            <app-page-wrapper
                :logo="{
                    url: '/static/img/logos/mdz-logo.png',
                    alt: 'Mini Dayz logo',
                    type: 'minidayz',
                }"
                :header-bg="isWebpSupported ? '/static/img/bg-header.webp' : '/static/img/bg-header.jpg'"
                :active-route="activeRoute"
                :nav-links="navLinks"
                :social-links="socialLinks"
                :user="user"
            >
                <spinner v-show="loading" />
                <div v-show="!loading">
                    <main>
                        <transition name="fade" mode="out-in">
                            <router-view></router-view>
                        </transition>
                    </main>
                    <app-footer
                        site-name="Mini DAYZ"
                        :pegi="16"
                        :social-links="socialLinks"
                        :copyright-links="copyrightLinks"
                    />
                </div>
            </app-page-wrapper>
        </template>
    </div>
</template>
<script>
import Notifications from "./partials/Notifications.vue";
import Spinner from "./partials/Spinner.vue";
import { MainPageWrapper, MainFooter } from "@bistudio/dayz-frontend-components";
import { mapActions, mapGetters } from "vuex";
import { HOME_PAGE_NAME, BLOG_PAGE_NAME, FAQ_PAGE_NAME, GEOBETA_PAGE_NAME } from "../router/names";
import links from "../data/links";
import webp from "../helpers/webp";

export default {
    name: "App",
    components: {
        spinner: Spinner,
        "app-footer": MainFooter,
        "app-notifications": Notifications,
        "app-page-wrapper": MainPageWrapper,
    },
    data() {
        return {
            webpChecked: false,
            description:
                "Explore a randomly generated map and scavenge for food, ammo and supplies.Use anything you find to craft advanced items. Protect yourself against aggressive infected and ferocious wolves.",
            navLinks: [
                { url: { name: GEOBETA_PAGE_NAME }, name: "MINI DAYZ 2", exact: true },
                // {
                //   name: "feedback",
                //   children: [
                //     {
                //       url: links.supportMobile,
                //       name: "Mobile version",
                //       icon: "mobile",
                //       external: true
                //     },
                //     {
                //       url: links.supportBrowser,
                //       name: "Browser version",
                //       icon: "desktop",
                //       external: true
                //     }
                //   ]
                // },
                { url: { name: FAQ_PAGE_NAME }, name: "faq" },
                { url: { name: BLOG_PAGE_NAME }, name: "blog" },
                { url: { name: HOME_PAGE_NAME }, name: "MINI DAYZ 1" },

                {
                    url: "https://forums.bohemia.net/forums/forum/193-minidayz/",
                    name: "forums",
                    external: true,
                },
            ],
            socialLinks: [
                { url: links.facebook, type: "facebook" },
                { url: links.twitter, type: "twitter" },
                { url: links.youtube, type: "youtube" },
                { url: links.vk, type: "vk" },
            ],
            copyrightLinks: [
                { url: links.cookies, name: "cookies" },
                { url: links.privacyPolicy, name: "privacy policy" },
            ],
        };
    },
    metaInfo() {
        return {
            titleTemplate(titleChunk) {
                // If undefined or blank then we don't need the hyphen
                return titleChunk ? `${titleChunk} | Mini DAYZ` : "Mini DAYZ | Official website";
            },
            meta: [
                // TODO: test it in facebook and twitter debugger
                { vmid: "description", name: "description", content: this.description },
                {
                    vmid: "og:description",
                    property: "og:description",
                    content: this.description,
                },
                { property: "og:url", content: this.url },
                { vmid: "og:type", property: "og:type", content: "website" },
                {
                    vmid: "og:image",
                    property: "og:image",
                    content: "/static/img/socials.jpg",
                },
                { property: "og:title", conent: "" }, // TODO: add dynamic title
            ],
        };
    },
    computed: {
        ...mapGetters("settings", {
            isWebpSupported: "isWebpSupported",
        }),
        activeRoute() {
            return this.$route.name;
        },
        onlyView() {
            return this.$route.meta.onlyView;
        },
        loading() {
            return this.$store.state.settings.loading;
        },
        url() {
            return this.$store.state.settings.origin + this.$store.state.route.path;
        },
        user() {
            return this.$store.state.user.user;
        },
    },
    async created() {
        // set current base url for proper og tags
        this.$store.commit("settings/setOrigin", window.location.origin);
        try {
            let isSupported = await webp.isSupported();
            this.$store.commit("settings/webp", isSupported);
            this.webpChecked = true;
        } catch (err) {
            this.webpChecked = true;
            this.$store.commit("settings/webp", false);
        }
        this.fetchUser();
    },
    methods: {
        ...mapActions("user", {
            fetchUser: "fetchUser",
        }),
    },
    mounted() {
        // TODO: add dynamic version
        console.log(
            "\n __  __ _       _   ____    _ __   _______\n|  \\/  (_)_ __ (_) |  _ \\  / \\\\ \\ / /__  /\n| |\\/| | | '_ \\| | | | | |/ _ \\\\ V /  / / \n| |  | | | | | | | | |_| / ___ \\| |  / /_ \n|_|  |_|_|_| |_|_| |____/_/   \\_\\_| /____|\n\n           Bohemia Interactive\n              version 1.0.0"
        );
    },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
